<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section class="ion-margin-bottom ion-padding-bottom">
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <span>What's On</span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <span>Movies</span>
      </li>
    </ul>

    <!-- HEADING & CATEGORY SELECT -->
    <ion-row class="listing-header ion-align-items-center">
      <ion-col class="ion-no-padding">
        <ion-text color="dark">
          <h1 class="h2 page-title">{{data?.title | uppercase}}</h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <!-- INTRO -->
    <app-paragraph
      [node]="{text: data?.excerpt}"
      [readMore]="true"
      class="page-intro"></app-paragraph>

    <ion-row class="title-container"
      ><ion-col size="12">
        <ion-text class="h5"
          >Showing {{ items?.length || 0 }} movies in {{ selectedLabel
          }}</ion-text
        ></ion-col
      >
    </ion-row>
    <ion-row
      ><ion-col size="12">
        <app-button
          [ngClass]="{ 'active-filter': selectedSection === section.key }"
          *ngFor="let section of sections"
          (click)="toggleSelectedSection(section?.key)"
          type="secondary"
          class="filter-btn"
          >{{section.label}}</app-button
        ></ion-col
      >
    </ion-row>

    <!-- SKELETON -->
    <section *ngIf="!items" class="ion-margin-bottom ion-padding-bottom">
      <!-- LISTING GRID -->
      <ion-grid class="ion-margin-bottom ion-padding-bottom">
        <ion-row>
          <ion-col size="6" size-md="3" *ngFor="let card of [0,1,2,3,4,5,6,7]">
            <ion-card>
              <ion-skeleton-text
                animated
                style="
                  padding-top: 144%;
                  margin-bottom: 0;
                  border-radius: 0;
                "></ion-skeleton-text>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>

    <section *ngIf="items" class="ion-margin-bottom ion-padding-bottom">
      <!-- LISTING GRID -->
      <ion-grid class="movies-grid ion-margin-bottom ion-padding-bottom">
        <!-- RESULTS -->
        <ion-row>
          <ion-col size="6" size-md="3" *ngFor="let item of items; trackBy: trackByID">
            <app-movie-card *ngIf="item.uuid" [movie]="item"></app-movie-card>
          </ion-col>
        </ion-row>

        <!-- NO RESULTS -->
        <ion-row *ngIf="items?.length === 0">
          <ion-col>
            <h3 *ngIf="!selectedCategory; else hasMovies">
              There are currently no movies. Please view the full list
              <a [href]="cinemaProvider.listingUrl" target="_blank">here</a>
            </h3>
            <ng-template #hasMovies>
              <h3>
                There are currently no movies in the
                <i>{{selectedCategory.title}}</i> category.
              </h3>
              <app-button
                type="secondary"
                (click)="resetCategories()"
              >
                View all Movies
              </app-button>
            </ng-template>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
